export default "__VITE_ASSET__F_JbfR7e__"